import { query_product_order_list } from '@/api/jms-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '订单单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写订单单号',
    },
    {
      type: 'remotemodal',
      name: 'order_id',
      label: '隶属报单',
      disabled: false,
      placeholder: '请选择隶属报单',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-requestorder',
    },
    {
      type: 'remotemodal',
      name: 'franchisee_id',
      label: '加盟商',
      disabled: false,
      placeholder: '请选择加盟商',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-franchisee',
    },
    {
      type: 'remotemodal',
      name: 'product_id',
      label: '产品',
      disabled: false,
      placeholder: '请选择产品',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-product',
    },
    {
      type: 'rangepicker',
      name: 'date',
      label: '下单时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写下单时间',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    code: null,
    order_id: null,
    franchisee_id: null,
    product_id: null,
    date: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '订单单号',
    width: 150,
    dataIndex: 'code',
    fixed: false,
    checked: true,
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'order_id',
    fixed: false,
    checked: false,
  },
  {
    title: '报单单号',
    width: 150,
    dataIndex: 'order__code',
    fixed: false,
    checked: true,
  },
  {
    title: '加盟商ID',
    width: 150,
    dataIndex: 'franchisee_id',
    fixed: false,
    checked: false,
  },
  {
    title: '名称',
    width: 150,
    dataIndex: 'franchisee__name',
    fixed: false,
    checked: true,
  },
  {
    title: '产品ID',
    width: 150,
    dataIndex: 'product_id',
    fixed: false,
    checked: false,
  },
  {
    title: '产品编码',
    width: 150,
    dataIndex: 'product__code',
    fixed: false,
    checked: true,
  },
  {
    title: '产品名称',
    width: 150,
    dataIndex: 'product__name',
    fixed: false,
    checked: true,
  },
  {
    title: '产品数量',
    width: 150,
    dataIndex: 'num',
    fixed: false,
    checked: true,
  },
  {
    title: '产品余次',
    width: 150,
    dataIndex: 'no_num',
    fixed: false,
    checked: true,
  },
  {
    title: '产品单价',
    width: 150,
    dataIndex: 'price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '产品金额',
    width: 150,
    dataIndex: 'total_price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '下单时间',
    width: 150,
    dataIndex: 'date',
    fixed: false,
    checked: true,
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    fixed: false,
    checked: true,
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_product_order_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
